import { ConnectedPosition } from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FilterOptionsType, FilterOperator, ISPagination, ISMultiSelectComponent, ISMultiSelectOption, DatePickerType, ISDialogService, MVListingConfigs, MVFilter, MVPagination, MVOrdering } from 'is-lib';
import { catchError, distinctUntilChanged, EMPTY, finalize, forkJoin, from, map, mergeMap, Observable, of, shareReplay, Subject, Subscription, switchMap, toArray } from 'rxjs';
import { Grouping, IGrouping } from 'src/app/models/Grouping';
import { OpportunityFormComponent } from '../../opportunities/opportunity-form/opportunity-form.component';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { UsersService } from 'src/app/services/users.service';
import { OpportunitiesService } from 'src/app/services/opportunities.service';
import { IClientPortalUser } from 'src/app/models/Client';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupingsService } from 'src/app/services/groupings.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { ElectricityMeterConsumption, NaturalGasMeterConsumption } from 'src/app/models/EnergyConsumptions';
import { differenceInCalendarMonths, differenceInMilliseconds, endOfQuarter, endOfYear, format, startOfQuarter, startOfYear, subMonths, subYears } from 'date-fns';
import { LanguageService } from 'src/app/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { PriceService } from 'src/app/services/prices.service';
import { IPrice } from 'src/app/models/Price';
import * as _ from 'lodash';
import { ApexAnnotations, ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexFill, ApexGrid, ApexLegend, ApexMarkers, ApexStroke, ApexTooltip, ApexXAxis, ApexYAxis } from 'apexcharts'
import { MatDialog } from '@angular/material/dialog';
import { NewOpportunityFormComponent } from '../../opportunities/opportunity-form/new-opportunity-form.component';
import { SnackBarService } from 'src/app/services/snackbar.service';
import { EnergyMetersService } from 'src/app/services/energyMeters.service';
import { IElectricityMeter, INaturalGasMeter } from 'src/app/models/EnergyMeter';
import { GroupingSimulation } from 'src/app/models/ContractPrice';
import { ObjectHelpers } from 'src/app/helpers/custom-functions';
import { pt } from 'date-fns/locale';
import { SupplierProductEconomicConditionsService } from 'src/app/services/supplierProductEconomicConditions.service';
import { IContract, IContractDetails } from 'src/app/models/Contract';
import { ContractsService } from 'src/app/services/contracts.service';
import { PricePeriods } from 'src/app/models/PricePeriod';
import { ElectricityPrice } from 'src/app/models/EnergyPrice';
import { isAfter } from 'date-fns/fp';
// Aliased: models/Contract also exports an IContract (the contracts list item)
import { IContract as IContractForm } from 'src/app/models/ContractResponse';

@Component({
    selector: 'app-grouping-view',
    templateUrl: './grouping-view.component.html',
    styleUrls: ['./grouping-view.component.scss']
})
export class GroupingViewComponent implements OnInit {

    // The opportunity/contract select and the equipments select, in template order. The equipments one only exists while there's a selection.
    @ViewChildren('equipmentGroupMultiSelect, equipmentsMultiSelect') multiSelects?: QueryList<ISMultiSelectComponent>;

    get equipmentGroupMultiSelect(): ISMultiSelectComponent | undefined {
        return this.multiSelects?.get(0);
    }

    get equipmentsMultiSelect(): ISMultiSelectComponent | undefined {
        return this.multiSelects?.get(1);
    }

    // Bound to the selects' externalLoading input instead of set through the ViewChildren: the loads start before the selects exist
    // (the group options load from ngOnInit, and the equipments select is only rendered once the selection that triggers its load is made)
    protected equipmentGroupLoading: boolean = false;
    protected equipmentsLoading: boolean = false;

    @ViewChild("electricityFilledMeterQuantity") set electricityFilledMeterQuantity(meterElement: ElementRef) {
        // if (meterElement) {
        //     let meterElementHtml = (meterElement.nativeElement as HTMLElement)
        //     let availableQuantity = (this.topPrice!.electricityQuantityAvailable ?? 1);
        //     let consumptionPercentage = this.electricityConsumptionPercentage;

        //     if (consumptionPercentage > 100) {
        //         consumptionPercentage = 100;
        //     }

        //     meterElement.nativeElement.style.left = `calc(${(consumptionPercentage ?? 0)}% - ${(availableQuantity ?? 0).toString().length + 1.5}ch`
        // }
    }

    @ViewChild("naturalGasFilledMeterQuantity") set naturalGasFilledMeterQuantity(meterElement: ElementRef) {
        // if (meterElement) {
        //     let meterElementHtml = (meterElement.nativeElement as HTMLElement)
        //     let availableQuantity = (this.topPrice!.naturalGasQuantityAvailable ?? 1);
        //     let consumptionPercentage = this.naturalGasConsumptionPercentage;

        //     if (consumptionPercentage > 100) {
        //         consumptionPercentage = 100;
        //     }

        //     meterElement.nativeElement.style.left = `calc(${(consumptionPercentage ?? 0)}% - ${(availableQuantity ?? 0).toString().length + 1.5}ch`
        // }
        
    }

    
    chartOptions?: Partial<ChartOptions>;

    requestsCompleteFlag: boolean = false;

    groupings: Grouping[] = [];
    contracts: IContract[] = [];
    opportunity: any;
    // Details of the selected contract, sent to the hedging view to filter the offers by the contract's conditions
    selectedContract: IContractForm | null = null;
    private _selectedContractSubscription?: Subscription;

    datePickerType = DatePickerType.date;

    user?: IClientPortalUser;

    selectedGroupingId!: string;
    selectedPrice: number = 0;
    
    marketDealersForm = new FormGroup({
        // Single value from the opportunities/contracts select, e.g. 'opportunity:<id>' or 'contract:<guid>'
        selection: new FormControl<string[] | null>(null),
        opportunityId: new FormControl<string | null>(null),
        contractId: new FormControl<string | null>(null),

        marketType: new FormControl<'NaturalGas' | 'Electricity'>('Electricity'),
        percentage: new FormControl<number | null>(null, [Validators.min(-100), Validators.max(100)]),

        filters: new FormGroup({
            equipments: new FormControl<any[]>([]),

            tensionLevel: new FormControl(),
            _tensionLevelValue: new FormControl(),
            power: new FormControl(),
            timeCycle: new FormControl(),
            countingCycle: new FormControl(),
            _powerValue: new FormControl(),
            _timeCycleDescription: new FormControl(),
            _countingCycleDescription: new FormControl(),
            pressureLevel: new FormControl(),
            _pressureLevelValue: new FormControl(),
            tier: new FormControl(),
            _tierDescription: new FormControl(),
            tariff: new FormControl(),
            _tariffDescription: new FormControl(),  
        })
    })

    // Opportunities (to create a proposal) and the client's active contracts (to edit), grouped in one select
    selectionOptions: ISMultiSelectOption[] = [];
    readonly ACTIVE_CONTRACT_STATUSES = ['Active', 'Accepted', 'InActivation', 'Inserted'];
    private _selectionDataSubscription?: Subscription;

    canChoosePercentage: boolean = false;
    // Custom percentage popover: below the button, or above when there is no room
    customPercentageOverlayPositions: ConnectedPosition[] = [
        { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 10, panelClass: 'md-popover--below' },
        { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -10, panelClass: 'md-popover--above' }
    ];
    //isCustomPercentageSet: boolean = false;
    customPercentage: number = 0;
    selectedPercentage: number = 0;
    fixedPercentages = [5, 10, 15, 20, -5, -10, -15, -20];

    electricityEquipments: GroupingSimulation.ElectricityEquipment[] = [];
    naturalGasEquipments: GroupingSimulation.NaturalGasEquipment[] = [];
    equipmentMultiSelectOptions: ISMultiSelectOption[] = [];

    electricityPrices: PricePeriods.ElectricityPrices[] = [];
    prices: IPrice[] = []
    pricesForHtml: any[] = [];

    electricityDetailsObjects: {
        tensionLevels?: {[id: string]: string},
        countingCycles?: {[id: string]: string},
        timeCycles?: {[id: string]: string}
    } = {}

    naturalGasDetailsObjects: {
        pressureLevels?: {[id: string]: string},
        tariffs?: {[id: string]: string},
        tiers?: {[id: string]: string}
    } = {}

    electricityPricesUpdate$ = new Subject<PricePeriods.ElectricityPrices[]>();

    // Fills electricityDetailsObjects / naturalGasDetailsObjects once; every selection waits on it instead of requesting the lookups again
    private _detailsObjects$!: Observable<void>;

    constructor( 
        private _dialogService: ISDialogService, 
        private _usersService: UsersService, 
        private _opportunitiesService: OpportunitiesService, 
        private _energyMeterService: EnergyMetersService,
        private _activatedRoute: ActivatedRoute, 
        private _groupingService: GroupingsService, 
        private _breadcrumbService: BreadcrumbService, 
        private _languageService: LanguageService,
        private _translateService: TranslateService,
        private _router: Router,
        private _cdRef: ChangeDetectorRef,
        private _priceService: PriceService,
        private _dialog: MatDialog,
        private _snackbarService: SnackBarService,
        private _spEconomicConditionService: SupplierProductEconomicConditionsService,
        private _contractsService: ContractsService
    ) {
        this.user = _usersService.userData!;
    }

    ngOnInit(): void {
        this._detailsObjects$ = this.loadDetailsObjects();
        // Starts loading the lookups with the page so the first selection doesn't have to wait for them
        this._detailsObjects$.subscribe();
        this.callServices();
        this.formSubscriptions();
    }

    getOpportunityData(opportunityId: string) {
        this.loadSelectionData(
            this._opportunitiesService.getOpportunityElectricityMeters(opportunityId),
            this._opportunitiesService.getOpportunityNaturalGasMeters(opportunityId),
            this._opportunitiesService.getOpportunity(opportunityId).pipe(
                catchError( err => of(null) )
            )
        );
    }

    getContractData(contractId: string) {
        this.loadSelectionData(
            this.getContractElectricityMeters(contractId),
            this.getContractNaturalGasMeters(contractId),
            of(null)
        );
    }

    // Contract supplies only carry the meter code, so the meter details (ids, cycles, power) come from the meters API.
    // The result has the same shape as an opportunity's meters so both go through loadSelectionData.
    private getContractElectricityMeters(contractId: string): Observable<ServerResponse<IElectricityMeter[]>> {
        return this._contractsService.getContractElectricitySupplies(contractId).pipe(
            switchMap( sr => {
                let supplies = sr.data ?? [];

                if (supplies.length == 0) {
                    return of([]);
                }

                return forkJoin(supplies.map( supply =>
                    this._energyMeterService.getElectricityMeterByCode(supply.electricityMeterCode).pipe(
                        map( sr_meter => {
                            let meter = sr_meter.data;

                            if (!meter) {
                                return null;
                            }

                            let mappedMeter: IElectricityMeter = {
                                originId: supply.guidId,
                                electricityMeterId: meter.id,
                                electricityMeterCode: meter.code,
                                electricityMeterContractedPower: meter.contractedPower ?? supply.contractedPower,
                                electricityMeterTensionLevel: meter.tensionLevel,
                                electricityMeterTensionLevelId: meter.tensionLevelId!,
                                electricityMeterCountType: meter.countType,
                                electricityMeterCountTypeId: meter.countTypeId!,
                                electricityMeterTimeCycle: meter.timeCycle,
                                electricityMeterTimeCycleId: meter.timeCycleId!,
                                estimatedAnnualConsumption: 0
                            };

                            return mappedMeter;
                        }),
                        catchError( err => of(null) )
                    )
                ));
            }),
            map( meters => {
                let foundMeters = meters.filter( (meter): meter is IElectricityMeter => meter != null );
                return new ServerResponse<IElectricityMeter[]>(foundMeters, '', foundMeters.length, '');
            })
        );
    }

    private getContractNaturalGasMeters(contractId: string): Observable<ServerResponse<INaturalGasMeter[]>> {
        return this._contractsService.getContractNaturalGasSupplies(contractId).pipe(
            switchMap( sr => {
                let supplies = sr.data ?? [];

                if (supplies.length == 0) {
                    return of([]);
                }

                return forkJoin(supplies.map( supply =>
                    this._energyMeterService.getNaturalGasMeterByCode(supply.naturalGasMeterCode).pipe(
                        map( sr_meter => {
                            let meter = sr_meter.data;

                            if (!meter) {
                                return null;
                            }

                            let mappedMeter: INaturalGasMeter = {
                                id: supply.guidId,
                                naturalGasMeterId: meter.id,
                                naturalGasMeterCode: meter.code,
                                naturalGasMeterPressureLevel: meter.pressureLevel,
                                naturalGasMeterPressureLevelId: meter.pressureLevelId!,
                                naturalGasMeterTariffOption: meter.tariffOption,
                                // The gas meter model has no tariff option id field declared
                                naturalGasMeterTariffOptionId: (meter as any).tariffOptionId,
                                naturalGasMeterTier: meter.tier,
                                naturalGasMeterTierId: meter.tierId!,
                                estimatedAnnualConsumption: 0
                            };

                            return mappedMeter;
                        }),
                        catchError( err => of(null) )
                    )
                ));
            }),
            map( meters => {
                let foundMeters = meters.filter( (meter): meter is INaturalGasMeter => meter != null );
                return new ServerResponse<INaturalGasMeter[]>(foundMeters, '', foundMeters.length, '');
            })
        );
    }

    // Loads the electricity and natural gas lookup tables (tension/pressure levels, cycles, tiers, tariffs) into the details objects.
    // Cached so the requests run only once, however many times the selection changes.
    private loadDetailsObjects(): Observable<void> {
        let requestsObject: {[key: string]: Observable<any>} = {
            tensionLevels: this._energyMeterService.getTensionLevels(),
            pressureLevels: this._energyMeterService.getPressureLevels()
        };

        if (this._usersService.userCountryCode.toLowerCase() == 'pt') {
            Object.assign(requestsObject, {
                countingCycles: this._energyMeterService.getCountingCycles(),
                timeCycles: this._energyMeterService.getTimeCycles(),
                tiers: this._energyMeterService.getTiers(),
                tariffs: this._energyMeterService.getTariffs(),
            });
        } else {
            Object.assign(requestsObject, {
                electricityTariffs: this._energyMeterService.getElectricityTariffs(),
                naturalGasTariffs: this._energyMeterService.getTariffs()
            });
        }

        return forkJoin( requestsObject ).pipe(
            map( (srs) => {
                // Some lookups only exist for PT, hence the empty fallbacks
                this.electricityDetailsObjects = {
                    tensionLevels: ObjectHelpers.mapArrayToObjectWithSpecificValue(srs['tensionLevels']?.data ?? [], (tensionLevel: any) => tensionLevel.id, (tensionLevel: any) => tensionLevel.description),
                    countingCycles: ObjectHelpers.mapArrayToObjectWithSpecificValue(srs['countingCycles']?.data ?? [], (countingCycle: any) => countingCycle.id, (countingCycle: any) => countingCycle.description),
                    timeCycles: ObjectHelpers.mapArrayToObjectWithSpecificValue(srs['timeCycles']?.data ?? [], (timeCycle: any) => timeCycle.id, (timeCycle: any) => timeCycle.description)
                }

                this.naturalGasDetailsObjects = {
                    pressureLevels: ObjectHelpers.mapArrayToObjectWithSpecificValue(srs['pressureLevels']?.data ?? [], (pressureLevel: any) => pressureLevel.id, (pressureLevel: any) => pressureLevel.description ),
                    tariffs: ObjectHelpers.mapArrayToObjectWithSpecificValue(srs['tariffs']?.data ?? [], (tariff: any) => tariff.id, (tariff: any) => tariff.description ),
                    tiers: ObjectHelpers.mapArrayToObjectWithSpecificValue(srs['tiers']?.data ?? [], (tier: any) => tier.id, (tier: any) => tier.description )
                }
            }),
            shareReplay(1)
        );
    }

    // Loads the meters' consumptions (after the lookup tables are available), then maps everything into simulation equipments
    loadSelectionData(
        electricityMeters$: Observable<ServerResponse<any[]>>,
        naturalGasMeters$: Observable<ServerResponse<any[]>>,
        opportunity$: Observable<any>
    ) {
        this.equipmentsLoading = true;

        let dateFrom = startOfYear(subYears(new Date(), 2)).toISOString();
        let dateTo = subMonths(new Date(), 1).toISOString();

        let requestsObject: {[key: string]: Observable<any>} = {
            electricity: electricityMeters$.pipe(
                switchMap(sr => {
                    if (sr.data && sr.data.length > 0) {
                        return forkJoin(sr.data.map(elecEquip => 
                            this._energyMeterService.getElectricityMeterConsumptions(elecEquip.electricityMeterId, dateFrom, dateTo).pipe(
                                map(sr_elecEquip => ({...elecEquip, consumptions: sr_elecEquip.data}))
                            )
                        ))
                    }
                    return of([])
                    
                }),
                map( elecEquips => new ServerResponse<any[]>(elecEquips, '', elecEquips.length, '') )
            ),
            naturalGas: naturalGasMeters$.pipe(
                switchMap(sr => {
                    if (sr.data && sr.data.length > 0) {
                        return forkJoin(sr.data.map(ntrlGasEquip => 
                            this._energyMeterService.getNaturalGasMeterConsumptions(ntrlGasEquip.naturalGasMeterId, dateFrom, dateTo).pipe(
                                map(sr_ntrlGasEquip => ({...ntrlGasEquip, consumptions: sr_ntrlGasEquip.data}))
                            )
                        ))
                    }
                    return of([])
                }),
                map( ntrlGasEquips => new ServerResponse<any[]>(ntrlGasEquips, '', ntrlGasEquips.length, '') )
            ),
            opportunity: opportunity$,
            detailsObjects: this._detailsObjects$
        };

        // A newer selection replaces any request still in flight
        this._selectionDataSubscription?.unsubscribe();
        this._selectionDataSubscription = forkJoin( requestsObject ).pipe(
            finalize(() => this.equipmentsLoading = false)
        ).subscribe({
            next: (srs) => {
                this.electricityEquipments = srs['electricity'].data.map( (elecMeter: IElectricityMeter & {consumptions: ElectricityMeterConsumption[]}) => {
                    let countingCycleDescription = this.electricityDetailsObjects.countingCycles?.[elecMeter.electricityMeterCountTypeId];
                    let timeCycleDescription = this.electricityDetailsObjects.timeCycles?.[elecMeter.electricityMeterTimeCycleId];

                    let mappedEquipment: GroupingSimulation.ElectricityEquipment = {
                        id: elecMeter.electricityMeterId,
                        guid: elecMeter.originId ?? elecMeter.id,
                        code: elecMeter.electricityMeterCode,
                        power: elecMeter.electricityMeterContractedPower,
                        tensionLevelDescription: elecMeter.electricityMeterTensionLevel,
                        tensionLevelId: elecMeter.electricityMeterTensionLevelId,
                        countingCycleId: elecMeter.electricityMeterCountTypeId,
                        countingCycleDescription: countingCycleDescription,
                        timeCycleId: elecMeter.electricityMeterTimeCycleId,
                        timeCycleDescription: timeCycleDescription,
                        priceData: [],
                        // Backend consumptions are in kWh; the simulation works in MWh
                        consumptions: elecMeter.consumptions.map( cons => new GroupingSimulation.ElectricityEquipmentConsumption(cons.date, cons.peak / 1000 , cons.standard / 1000 , cons.offPeak / 1000 , (cons.superOffPeak ?? 0) / 1000 ) )
                    }

                    return mappedEquipment;
                });

                this.naturalGasEquipments = srs['naturalGas'].data.map( (gasMeter: INaturalGasMeter & {consumptions: NaturalGasMeterConsumption[]}) => {
                    let tariffOptionDescription = this.naturalGasDetailsObjects.tariffs?.[gasMeter.naturalGasMeterTariffOptionId];
                    let tierDescription = this.naturalGasDetailsObjects.tiers?.[gasMeter.naturalGasMeterTierId];

                    let mappedEquipment: GroupingSimulation.NaturalGasEquipment = {
                        id: gasMeter.naturalGasMeterId,
                        guid: gasMeter.id,
                        code: gasMeter.naturalGasMeterCode,
                        pressureLevelDescription: gasMeter.naturalGasMeterPressureLevel,
                        pressureLevelId: gasMeter.naturalGasMeterPressureLevelId,
                        tariffId: gasMeter.naturalGasMeterTariffOptionId,
                        tariffDescription: tariffOptionDescription,
                        tierId: gasMeter.naturalGasMeterTierId,
                        tierDescription: tierDescription,
                        priceData: [],              
                        // Backend consumptions are in kWh; the simulation works in MWh
                        consumptions: gasMeter.consumptions.map( cons => new GroupingSimulation.NaturalGasEquipmentConsumption(cons.date, cons.consumption / 1000) )
                    }

                    return mappedEquipment;
                });

                this.opportunity = srs['opportunity']?.data;

                this.populateEquipmentMultiSelect();
            },
        })
    }


    get currentEquipments(): (GroupingSimulation.ElectricityEquipment|GroupingSimulation.NaturalGasEquipment)[] {
        return this.selectedMarketType == 'Electricity' ? this.electricityEquipments : this.naturalGasEquipments; 
    }

    populateEquipmentMultiSelect() {
        let marketType = this.marketDealersForm.controls['marketType'].value
        
        this.equipmentMultiSelectOptions = this.currentEquipments.reduce( (msOptions, equipment, index) => {
            if (marketType == 'Electricity') {
                if (!Object.hasOwn(equipment, 'tensionLevelId')) {
                    return msOptions
                }

                let typedEquipment = equipment as GroupingSimulation.ElectricityEquipment;
                let groupLabel = '';
                let groupValue = '';
                
                if (typedEquipment.tensionLevelDescription == 'BTN') {
                    let countingCycleDescription = this.electricityDetailsObjects.countingCycles?.[typedEquipment.countingCycleId!]!;

                    countingCycleDescription = this._translateService.instant(countingCycleDescription);
                    groupLabel = typedEquipment.tensionLevelDescription + ' - ' + countingCycleDescription + ' - ' + typedEquipment.power + ' KVa';
                    groupValue = typedEquipment.tensionLevelId + ';' + typedEquipment.countingCycleId + ';' + typedEquipment.power;
                } else {
                    let timeCycleDescription = this.electricityDetailsObjects.timeCycles?.[typedEquipment.timeCycleId!]!;

                    timeCycleDescription = this._translateService.instant(timeCycleDescription);
                    groupLabel = typedEquipment.tensionLevelDescription + ' - ' + timeCycleDescription + ' - ' + typedEquipment.power + ' KVa';
                    groupValue = typedEquipment.tensionLevelId + ';' + typedEquipment.timeCycleId + ';' + typedEquipment.power;
                }
                
                if (!String.isNullOrUndefinedOrWhitespace(groupLabel)) {
                    let option = msOptions.find( (opt) => opt.label == groupLabel );

                    if (option) {
                        option.children!.push(new ISMultiSelectOption(typedEquipment.id, typedEquipment.code) )
                    } else {
                        option = new ISMultiSelectOption( 
                            groupValue,
                            groupLabel,
                            undefined,
                            undefined,
                            [
                                new ISMultiSelectOption(typedEquipment.id, typedEquipment.code)
                            ],
                            false
                        )

                        msOptions.push(option);
                    }
                }
            } else {
                if (!Object.hasOwn(equipment, 'pressureLevelId')) {
                    return msOptions
                }

                let typedEquipment = equipment as GroupingSimulation.NaturalGasEquipment;
                let groupLabel = '';
                let groupValue = '';

                if (typedEquipment.pressureLevelDescription == 'BP') {
                    let tierDescription = this.naturalGasDetailsObjects.tiers?.[typedEquipment.tierId!]!;

                    tierDescription = this._translateService.instant(tierDescription);
                    groupLabel = typedEquipment.pressureLevelDescription + ' - ' + tierDescription;
                    groupValue = typedEquipment.pressureLevelId + ';' + typedEquipment.tierId;
                } else {
                    if (typedEquipment.tariffId) {
                        let tariffDescription = this.naturalGasDetailsObjects.tariffs?.[typedEquipment.tariffId]!;

                        tariffDescription = this._translateService.instant(tariffDescription);
                        groupLabel = typedEquipment.pressureLevelDescription + ' - ' + tariffDescription;
                        groupValue = typedEquipment.pressureLevelId + ';' + typedEquipment.tariffId;
                    } else if (typedEquipment.tierId){
                        let tierDescription = this.naturalGasDetailsObjects.tiers?.[typedEquipment.tierId]!;

                        tierDescription = this._translateService.instant(tierDescription);
                        groupLabel = typedEquipment.pressureLevelDescription + ' - ' + tierDescription;
                        groupValue = typedEquipment.pressureLevelId + ';' + typedEquipment.tierId;
                    }
                    
                }

                if (!String.isNullOrUndefinedOrWhitespace(groupLabel)) {
                    let option = msOptions.find( (opt) => opt.label == groupLabel );

                    if (option) {
                        option.children!.push(new ISMultiSelectOption(typedEquipment.id, typedEquipment.code) )
                    } else {
                        option = new ISMultiSelectOption( 
                            groupValue,
                            groupLabel,
                            undefined,
                            undefined,
                            [
                                new ISMultiSelectOption(typedEquipment.id, typedEquipment.code)
                            ],
                            false
                        )

                        msOptions.push(option);
                    }
                }
                
            }
            
            return msOptions;
        }, new Array<ISMultiSelectOption>())
    }

    getFilteredElectricityEquipments(): GroupingSimulation.ElectricityEquipment[] {
        let filters = this.filtersForm.value;
        return this.electricityEquipments.filter( (equip) => {
            if (!filters.tensionLevel) {
                return true;
            }

            if (filters._tensionLevelValue == 'BTN') {
                if (filters._powerValue && filters.countingCycle) {
                    return equip.tensionLevelId == filters.tensionLevel && equip.power == filters._powerValue && equip.countingCycleId == filters.countingCycle; 
                }
            } else if (filters._tensionLevelValue == 'BTE') {
                if (filters._powerValue && filters.timeCycle) {
                    return equip.tensionLevelId == filters.tensionLevel && equip.power == filters._powerValue && equip.timeCycleId == filters.timeCycle; 
                }
            } else {
                if (filters._powerValue) {
                    return equip.tensionLevelId == filters.tensionLevel && equip.power == filters._powerValue; 
                }
            }

            return false;
        } );
    }

    getFilteredNaturalGasEquipments() {
        let filters = this.filtersForm.value;

        return this.naturalGasEquipments.filter( (equip) => {
            if (!filters.pressureLevel) {
                return true;
            }

            if (filters._pressureLevelValue == 'BP') {
                if (filters.tariff) {
                    return equip.pressureLevelId == filters.pressureLevel && equip.tariffId == filters.tariff; 
                } else if (filters.tier) {
                    return equip.pressureLevelId == filters.pressureLevel && equip.tierId == filters.tier; 
                }
            } else {
                if (filters.tariff) {
                    return equip.pressureLevelId == filters.pressureLevel && equip.tariffId == filters.tariff; 
                }
            }
            
            return false;
        } );
    }

    getFilteredEquipments(): GroupingSimulation.IEquipment[] {
        if (this.selectedMarketType == 'Electricity') {
            return this.getFilteredElectricityEquipments();
        } else {
            return this.getFilteredNaturalGasEquipments();
        }
    }

    callServices() {
        const groupingName = this._breadcrumbService.breadCrumbTitle.at(-1)
        
        if (!String.isNullOrUndefinedOrWhitespace(groupingName)) {
            let groupingsAPI = new MVListingConfigs([
                new MVFilter('InternalCode', groupingName, FilterOptionsType.text, FilterOperator.equals),
            ],
            null,
            new MVPagination(0, 999)
        );

            this._groupingService.getGroupings(groupingsAPI, true).pipe(
                switchMap((sr_groupings: ServerResponse<IGrouping[]>) => {
                    if (sr_groupings.data && sr_groupings.data.length == 1) {
                        this.selectedGroupingId = sr_groupings.data[0].id!;
                        this.loadSelectionOptions().subscribe();
                        // return this._groupingService.getGroupingPrices(sr_groupings.data[0].id!).pipe(
                        //     map( sr_prices => ({
                        //         grouping: sr_groupings.data[0],
                        //         prices: sr_prices.data ?? []
                        //     }))
                        // )
                        return EMPTY;
                    } else {
                        return EMPTY
                    }
                })
            ).subscribe( (responseObject) => {
            });
        }
    }

    // Builds the two groups of the select: the grouping's opportunities and the client's active contracts
    loadSelectionOptions(): Observable<void> {
        let contractsConfig = new MVListingConfigs(
            [ 
                new MVFilter('InvariantCultureDescription', this.ACTIVE_CONTRACT_STATUSES.join('|'), FilterOptionsType.text, FilterOperator.in, 'FkContractStatusNavigation')
            ],
            new MVOrdering('MVContractNumber', 'asc'),
            new ISPagination(999, 0)
        );

        this.equipmentGroupLoading = true;

        return forkJoin({
            opportunities: this._groupingService.getGroupingOpportunities(this.selectedGroupingId, undefined, false).pipe( catchError( err => of(null) ) ),
            contracts: this._contractsService.getContracts(contractsConfig, false).pipe( catchError( err => of(null) ) )
        }).pipe(
            map( (srs) => {
                let opportunities: { id: string, number: string }[] = srs.opportunities?.data ?? [];
                let contracts: IContract[] = srs.contracts?.data ?? [];

                this.selectionOptions = [
                    new ISMultiSelectOption(
                        'EQUIPMENT_GROUPS',
                        this._translateService.instant('EQUIPMENT_GROUPS'),
                        undefined,
                        undefined,
                        opportunities.map( (opp) => new ISMultiSelectOption('opportunity:' + opp.id, opp.number) )
                    ),
                    new ISMultiSelectOption(
                        'CONTRACTS',
                        this._translateService.instant('CONTRACTS'),
                        undefined,
                        undefined,
                        contracts.map( (contract) => new ISMultiSelectOption('contract:' + contract.guidId, contract.contractNumber) )
                    )
                ].filter( (group) => group.children!.length > 0 );
            }),
            finalize( () => this.equipmentGroupLoading = false )
        );
    }

    protected get hasSelection(): boolean {
        return !this.isNullOrUndefinedOrWhitespace(this.marketDealersForm.controls.opportunityId.value!)
            || !this.isNullOrUndefinedOrWhitespace(this.marketDealersForm.controls.contractId.value!);
    }

    isCustomPercentageDuplicate(): boolean {
        const val = Number(this.marketDealersForm.controls.percentage.value);
        return this.fixedPercentages.includes(val);
    }

    // isPercentageChosen(): number {
    //     if()
    // }

    protected openPriceView(priceId?: string) {
        this._router.navigate(['price', priceId], {relativeTo: this._activatedRoute, queryParams: { groupingId: this.selectedGroupingId }});
    }

    protected openOpportunityCreationDialog(priceId?: string) {
        this._dialogService.open(
            OpportunityFormComponent,
            {
                title: this._translateService.instant('NEW_EQUIPMENT_GROUP'),
                data: {
                    groupingId: this.selectedGroupingId,
                    priceId: priceId,
                    opportunityId: this.marketDealersForm.controls.opportunityId.value
                },
                dialogConfig: {
                    dialogColor: 'white',
                    dialogBackgroundColor: '#0034CF',
                    iconColor: 'white',
                    iconHoverColor: 'grey'
                },
                width: 1345,
                height: 744
            }
        ).afterClosed.subscribe( (oppId) => this.selectCreatedOpportunity(oppId) );

    }

    // Reloads the select so the new opportunity is listed, then selects it
    private selectCreatedOpportunity(oppId: string) {
        if (oppId && !String.isNullOrUndefinedOrWhitespace(oppId)) {
            this.loadSelectionOptions().subscribe(() => {
                this.marketDealersForm.controls.selection.setValue(['opportunity:' + oppId]);
            });
        }
    }

    protected openNewOpportunityCreationDialog(priceId?: string) {
        this._dialog.open(
            NewOpportunityFormComponent,
            {
                data: {
                    groupingId: this.selectedGroupingId,
                    priceId: priceId,
                    opportunityId: this.marketDealersForm.controls.opportunityId.value ?? ''
                },
                width: '1250px'
            }
        ).afterClosed().subscribe( (oppId) => this.selectCreatedOpportunity(oppId) );
        /*this._dialogService.open(
            OpportunityFormComponent,
            {
                title: this._translateService.instant('NEW_EQUIPMENT_GROUP'),
                data: {
                    groupingId: this.selectedGroupingId,
                    priceId: priceId,
                    opportunityId: this.marketDealersForm.controls.opportunityId.value
                },
                dialogConfig: {
                    dialogColor: 'white',
                    dialogBackgroundColor: '#0034CF',
                    iconColor: 'white',
                    iconHoverColor: 'grey'
                },
                width: 1345,
                height: 744
            }
        )*/
    }

    protected openNewOpportunityEditDialog(opportunityId?: string) {
        this._dialog.open(
            NewOpportunityFormComponent,
            {
                data: {
                    groupingId: this.selectedGroupingId,
                    opportunityId: this.marketDealersForm.controls.opportunityId.value
                },
                width: '1250px'
            }
        );
    }
    
    protected formSubscriptions() {
        this.marketDealersForm.controls.marketType.valueChanges.subscribe( (eqType: any) => {
            this.electricityPrices = [];
            this.electricityPricesUpdate$.next([]);

            this.marketDealersForm.controls.filters.controls.equipments.setValue([]);
            this.populateEquipmentMultiSelect();
        } )

        // The grouped select sets either the opportunity (to create a proposal) or the contract (to edit)
        this.marketDealersForm.controls.selection.valueChanges.subscribe( (selection: string[] | null) => {
            let [type, id] = (selection?.[0] ?? '').split(':');

            this.marketDealersForm.patchValue({
                opportunityId: type == 'opportunity' ? id : null,
                contractId: type == 'contract' ? id : null
            });
        })

        this.marketDealersForm.controls.opportunityId.valueChanges.pipe( distinctUntilChanged() ).subscribe( (oppId: any) => {
            if (!String.isNullOrUndefinedOrWhitespace(oppId)) {
                this.getOpportunityData(oppId);
            }

            this.filtersForm.controls.equipments.setValue([]);
        })

        this.marketDealersForm.controls.contractId.valueChanges.pipe( distinctUntilChanged() ).subscribe( (contractId: string | null) => {
            this._selectedContractSubscription?.unsubscribe();
            this.selectedContract = null;

            if (!String.isNullOrUndefinedOrWhitespace(contractId)) {
                this.getContractData(contractId!);

                this._selectedContractSubscription = this._contractsService.getContract(contractId!).pipe(
                    catchError( () => of(null) )
                ).subscribe( (response) => this.selectedContract = response?.data ?? null );
            }

            this.filtersForm.controls.equipments.setValue([]);
        })

        this.filtersForm.controls.equipments.valueChanges.subscribe( (equipmentChange: any[] | null) => {
            let selectedGroup = this.getEquipmentGroupOption(equipmentChange);

            if (selectedGroup) {
                let selectedEquipmentDataIds = selectedGroup.value.split(';');

                if (this.selectedMarketType == 'Electricity') {
                    let tensionLevelDescription = this.electricityDetailsObjects.tensionLevels?.[selectedEquipmentDataIds[0]];
                    
                    if (tensionLevelDescription == 'BTN') {   
                        let countingCycleDescription = this.electricityDetailsObjects.countingCycles?.[selectedEquipmentDataIds[1]];

                        this.filtersForm.patchValue({
                            tensionLevel: selectedEquipmentDataIds[0],
                            _tensionLevelValue: tensionLevelDescription,
                            countingCycle: selectedEquipmentDataIds[1],
                            _countingCycleDescription: countingCycleDescription,
                            _powerValue: selectedEquipmentDataIds[2],
                        });
                    } else {
                        let timeCycleDescription = this.electricityDetailsObjects.timeCycles?.[selectedEquipmentDataIds[1]];

                        this.filtersForm.patchValue({
                            tensionLevel: selectedEquipmentDataIds[0],
                            _tensionLevelValue: tensionLevelDescription,
                            timeCycle: selectedEquipmentDataIds[1],
                            _timeCycleDescription: timeCycleDescription,
                            _powerValue: selectedEquipmentDataIds[2],
                            
                        })
                    }
                } else {
                    let pressureLevelDescription = this.naturalGasDetailsObjects.pressureLevels?.[selectedEquipmentDataIds[0]];
                    let tariffDescription = this.naturalGasDetailsObjects.tariffs?.[selectedEquipmentDataIds[1]] ?? undefined;
                    let tierDescription = this.naturalGasDetailsObjects.tiers?.[selectedEquipmentDataIds[1]] ?? undefined;
                    
                    this.filtersForm.patchValue({
                            pressureLevel: selectedEquipmentDataIds[0],
                            _pressureLevelValue: pressureLevelDescription,
                        })

                    if (tariffDescription) {
                        this.filtersForm.patchValue({
                            tariff: selectedEquipmentDataIds[1],
                            _tariffDescription: tariffDescription,
                        })
                    }

                    if (tierDescription) {
                        this.filtersForm.patchValue({
                            tier: selectedEquipmentDataIds[1],
                            _tierDescription: tierDescription,
                        })
                    }
                }

                this.populatePrices();
            } else {
                this.filtersForm.patchValue({
                    tensionLevel: null,
                    _tensionLevelValue: null,
                    countingCycle: null,
                    _countingCycleDescription: null,
                    _powerValue: null,
                    pressureLevel: null,
                    _pressureLevelValue: null,
                    tariff: null,
                    _tariffDescription: null,
                    tier: null,
                    _tierDescription: null,
                    timeCycle: null,
                    _timeCycleDescription: null
                });
                
                this.electricityPricesUpdate$.next([])
            }
        })
    }

    populatePrices() {
        this.electricityPrices = [];
        
        let requestBody: {[key:string]: string} = {
            contractedPower: this.filtersForm.controls._powerValue.value,
            tensionLevelId: this.filtersForm.controls.tensionLevel.value
        }

        if (this.filtersForm.controls._tensionLevelValue.value == 'BTN') {
            requestBody['countTypeId'] = this.filtersForm.controls.countingCycle.value
        } else {
            requestBody['timeCycleId'] = this.filtersForm.controls.timeCycle.value
        }

        this._priceService.getElectricityPricesForPortal(requestBody).pipe(
            catchError( err => 
                EMPTY
            )
        ).subscribe( sr => {
            this.electricityPrices = _.sortBy(sr.data.filter((price) => new Date(price.deliveryStartDate).getTime() > new Date().getTime()).map( (priceData) => 
                new PricePeriods.ElectricityPrices(
                        priceData.deliveryEndDate,
                        priceData.deliveryStartDate,
                        priceData.priceReference,
                        priceData.description,
                        priceData.id,
                        priceData.priceOne,
                        priceData.priceTwo,
                        priceData.priceThree,
                        priceData.priceFour,
                        priceData.sigaSPGeneralConditionId,
                        priceData.sigaSPParticularConditionId,
                        priceData.sigaSPElecEconomicConditionId,
                        priceData.sigaSupplierProductId
                    )
            ),
            // Delivery year first, then longest period first (year, quarter, month...), then earliest start.
            // Duration is counted in calendar months so periods of the same kind tie (e.g. a 31-day December isn't "longer" than November).
            [
                (price) => new Date(price.deliveryStartDate).getFullYear(),
                (price) => -(differenceInCalendarMonths(new Date(price.deliveryEndDate), new Date(price.deliveryStartDate)) + 1),
                (price) => new Date(price.deliveryStartDate).getTime()
            ]);

            this.electricityPricesUpdate$.next(this.electricityPrices);

            let totalLatestConsumptions: {[key: string]: number}

            if (this.selectedMarketType == 'Electricity') {
                let latestConsumption = (this.selectedEquipments as GroupingSimulation.ElectricityEquipment[]).flatMap(equip => 
                    _.minBy(equip.consumptions, (consumption) => differenceInMilliseconds(Date.now(), new Date(consumption.date)))!
                );

                totalLatestConsumptions = latestConsumption.reduce( (totalConsumptions, consumption) => {
                    if (consumption) {
                        totalConsumptions.peak += consumption.peak;
                        totalConsumptions.standard += consumption.standard;
                        totalConsumptions.offPeak += consumption.offPeak;
                        totalConsumptions.superOffPeak += consumption.superOffPeak;
                    }

                    return totalConsumptions ;
                }, { peak: 0, standard: 0, offPeak: 0, superOffPeak: 0 })

                this.pricesForHtml = this.electricityPrices.map( (price) => {
                    let pricesObject = {};

                    pricesObject = {
                        peakPrice: (((price?.peak ?? 0) * totalLatestConsumptions['peak'])).toFixed(4),
                        offPeakPrice: (((price?.offPeak ?? 0) * totalLatestConsumptions['offPeak'])).toFixed(4),
                        standardPrice: (((price?.standard ?? 0) * totalLatestConsumptions['standard'])).toFixed(4),
                        superOffPeakPrice: (((price?.superOffPeak ?? 0) * totalLatestConsumptions['superOffPeak'])).toFixed(4),
                    
                        mwhLimit: undefined,
                        interestedConsumption: undefined
                    }

                    return {
                        datePeriod: this.getPriceTimelineString(price, undefined),
                        supplier: undefined,
                        priceExpiryDate: price.deliveryEndDate,
                        priceName: price.priceReference,
                        ...pricesObject 
                    }
                })
            } else {
                let latestConsumption = (this.selectedEquipments as GroupingSimulation.ElectricityEquipment[]).flatMap(equip => 
                    _.minBy(equip.consumptions, (consumption) => differenceInMilliseconds(Date.now(), new Date(consumption.date)))
                )
            }
        })
    }

    /**
     * Returns the equipment group (parent option) that contains the selected equipments
     * @param selectedEquipmentIds Ids of the selected equipments (children of the multiselect)
     */
    getEquipmentGroupOption(selectedEquipmentIds: any[] | null): ISMultiSelectOption | undefined {
        if (selectedEquipmentIds == null || selectedEquipmentIds.length == 0) {
            return undefined;
        }

        return this.equipmentMultiSelectOptions.find( (equipOption) => equipOption.children?.some( (child) => child.value == selectedEquipmentIds[0] ) );
    }

    get selectedEquipments():GroupingSimulation.ElectricityEquipment[] | GroupingSimulation.NaturalGasEquipment[] {
        if (this.filtersForm.controls.equipments.value && this.filtersForm.controls.equipments.value?.length > 0) {
            let selectedEquipmentMeterIds = this.filtersForm.controls.equipments.value;

            if (this.selectedMarketType == 'Electricity') {
                return this.currentEquipments.filter( (equip) => selectedEquipmentMeterIds?.some(id => equip.id == id) ) as GroupingSimulation.ElectricityEquipment[];
            } else {
                return this.currentEquipments.filter( (equip) => selectedEquipmentMeterIds?.some(id => equip.id == id) ) as GroupingSimulation.NaturalGasEquipment[];
            }
        }

        return []
    }

    // changePercetageBit(){
    //     if(!this.isCustomPercentageSet)
    //         this.isCustomPercentageSet = !this.isCustomPercentageSet;
    // }

    getPriceTimelineString(price: PricePeriods.ElectricityPrices, dateType: 'years' | 'quarters' | 'months' | undefined, formatLocale: Locale = pt) {
        if (!dateType) {
            if (price.deliveryStartDate == startOfYear(price.deliveryStartDate) && price.deliveryEndDate == endOfYear(price.deliveryEndDate)) {
                dateType = 'years'
            } else if (price.deliveryStartDate == startOfQuarter(price.deliveryStartDate) && price.deliveryEndDate == endOfQuarter(price.deliveryEndDate)) {
                dateType = 'quarters'
            } else {
                dateType = 'months'
            }
        }
        
        if (dateType == 'years') {
            return _.uniq([price.deliveryStartDate, price.deliveryEndDate].map( (date) => format(date, 'y', { locale: formatLocale }))).join(' - ');
        } else if (dateType == 'quarters') {
            return _.uniq([price.deliveryStartDate, price.deliveryEndDate].map( (date) => format(date, 'QQQ y', { locale: formatLocale }))).join(' - ');
        } else {
            return _.uniq([price.deliveryStartDate, price.deliveryEndDate].map( (date) => format(date, 'MMM y', { locale: formatLocale }))).join(' - ');
        }
    }

    clampPercentageInput(event: Event) {
        const input = event.target as HTMLInputElement;
        let value = Number(input.value);
        if (value < -100) 
            value = -100;
        if (value > 100) 
            value = 100;
        
        input.value = value.toString();
        this.marketDealersForm.controls.percentage.setValue(value, { emitEvent: false });
    }

    onCustomPercentageConfirm() {
        this.selectedPercentage = this.marketDealersForm.controls.percentage.value!;
        this.togglePriceAlert(this.marketDealersForm.controls.percentage.value!); // If this is needed for your logic
        //this.changePercetageBit();    // If this is needed for your logic
        this.canChoosePercentage = false; // Hide the input and button
        this.customPercentage = this.selectedPercentage; // Store the custom percentage
    }

    protected get selectedMarketType() {
        return this.marketDealersForm.controls.marketType.value!
    }

    protected get filtersForm() {
        return this.marketDealersForm.controls.filters;
    }

    protected togglePriceAlert( value: number ) {
        if (this.selectedPrice == value) {
            this.selectedPrice = 0;
        } else {
            this.selectedPrice = value;
        }
    }

    protected isNullOrUndefinedOrWhitespace(s: string) {
        return String.isNullOrUndefinedOrWhitespace(s);
    }

    protected getSeriesByName(name: string, seriesArray?: ApexAxisChartSeries): any | undefined {
        if (seriesArray) {
            return seriesArray.find( (serie) => serie.name == name);
        }

        return this.chartOptions?.series?.find( (serie) => serie.name == name);
    }

    protected get isParentRoute(): boolean {
        return this._router.url.endsWith('spot') || this._router.url.endsWith('hedging');
    }

    protected get isHedging(): boolean {
        return this._router.url.includes('hedging');
    }

    protected get isSpot(): boolean {
        return this._router.url.includes('spot');
    }
}

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    tooltip: ApexTooltip;
    dataLabels: ApexDataLabels;
    legend: ApexLegend;
    yaxis: ApexYAxis | ApexYAxis[];
    annotations: ApexAnnotations;
    markers: ApexMarkers;
    fill: ApexFill;
    grid: ApexGrid;
    colors: string[];
  };